import { useContext } from 'react';
import { MainContext } from 'components/layout/MainContext';
import { useLocation } from 'react-router-dom';

function useQueryStrings(key: string) {
    const query = new URLSearchParams(useLocation().search);
    return query.get(key);
}

export const useCongregationId = () => {
    const congregationIdQS = useQueryStrings('cid');
    const { congregationId, storeCongregationId } = useContext(MainContext);
    let currentCongregationId: number | null;

    if (congregationIdQS) {
        const value = parseInt(congregationIdQS);
        storeCongregationId(value);
        currentCongregationId = value;
    } else {
        currentCongregationId = congregationId;
    }

    return currentCongregationId;
};
